import { api } from "../../services/NetworkBase";

export async function GetEmailAccounts() {
    try {
        let response = await api
            .get(`vlp/email-accounts`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function UpdateEmailAccount(account) {
    try {
      let response = await api.put("vlp/email-accounts", { json: account });
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  export async function SaveEmailAccount(account) {
    try {
      let response = await api.post("vlp/email-accounts", {
        json: account,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  export async function DeleteEmailAccount(emailAccountId) {
    try {
      const encodedUrl = encodeURIComponent(emailAccountId);
      let response = await api
        .delete(`vlp/email-accounts/${encodedUrl}`)
        .json();
      return response;
    } catch (error) {
      throw error;
    }
  }